export default {
    API_ENDPOINT: 'https://infinite-spire-80617.herokuapp.com/api',
    TOKEN_KEY: 'star-trek-client-auth-token',
} 